import styled from "styled-components"

export const Container = styled.div`
  padding: 1rem;
`

export const Title = styled.div`
  font-size: 26px;
  font-weight: 600;
  text-align: center;
`

export const Actions = styled.div`
  display: flex;
  justify-content: center;
  gap: 64px;
  width: 100%;
`
